import React from "react";
import { NavLink } from "react-router-dom";
import applogo from "../../../imgs/zombie-logo.svg";
// import homeicon from '../../../imgs/homeicon.svg';
import settingIcon from "../../../imgs/settingsicon.svg";
import postIcon from "../../../imgs/post.svg";
import { Dropdown } from "antd";
import moreIcon from "../../../imgs/moreicon.svg";
import ProfileMoreMenu from "../profile/MoreMenu";
import { HomeIcon } from "../SvgIcons/SvgIcons";

const ProfileSideBar = () => {
  return (
    <div className="home-sidebar">
      <div className="app-logo">
        <img src={applogo} alt="logo" />
      </div>
      <div className="sidebar-menu">
        <div>
          <NavLink className="sidebar-links" to="/">
            <span>
              <HomeIcon />
            </span>
            Home
          </NavLink>
          <NavLink className="sidebar-links" to="/login">
            <span>
              <img src={settingIcon} alt="logo" />
            </span>
            Sign in
          </NavLink>
          <NavLink className="sidebar-links" to="/login">
            <span>
              <img src={postIcon} alt="logo" />
            </span>
            Post a bounty
          </NavLink>
        </div>
        <div className="more-menu">
          <Dropdown
            overlay={ProfileMoreMenu}
            placement="bottomCenter"
            trigger={["click"]}
          >
            <NavLink className="sidebar-links" to="/more">
              <span>
                <img src={moreIcon} alt="logo" />
              </span>
              More
            </NavLink>
          </Dropdown>
        </div>
      </div>
    </div>
  );
};

export default ProfileSideBar;
